module.exports = __webpack_public_path__ + "img/ico_badge14.c03c2f7a.svg";